import { InjectionToken } from '@angular/core';

export const TIME_TIMEZONE_STRING = new InjectionToken<string>('TimeTimezoneString');
export const TIME_MERIDIEM = new InjectionToken<boolean>('TimeMeridiem');
export const DATE_TIMEZONE_OVERRIDE = new InjectionToken<string>('DateTimezoneOverride');
